import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { getNewsById } from '../../shared/news/news';
import '../../App.css';
import BackToList from '../BackToList';
import ChangelogArticle from './ChangelogArticle';

export default function Article () {
    const { articleId } = useParams();
    const newsArticle = getNewsById(articleId);

    if (!newsArticle) {
        return (
            <Container className="gs-page">
                <div className="gs-page-gutter">
                    <BackToList to="/news" label="Back to Changelogs" />
                    <div className="gs-empty-state gs-empty-state--inline" role="status">
                        <h2>Changelog not found</h2>
                        <p>No changelog matches “{articleId}”.</p>
                        <div className="gs-empty-state__actions">
                            <Link to="/news" className="gs-btn">Browse Changelogs</Link>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <Container className="gs-page">
            <div className="gs-page-gutter">
                <BackToList to="/news" label="Back to Changelogs" />
                <ChangelogArticle
                    date={newsArticle.date}
                    intro={newsArticle.article.intro}
                    newUnits={newsArticle.article.new?.units}
                    newEquips={newsArticle.article.new?.equips}
                    newDream={newsArticle.article.new?.dream}
                    globalUnits={newsArticle.article.globalUpdate?.units}
                    globalEquips={newsArticle.article.globalUpdate?.equips}
                    globalDream={newsArticle.article.globalUpdate?.dream}
                    showReturn
                />
            </div>
        </Container>
    );
}
